import axios from 'axios'
import Vue from 'vue'

export async function fetchMenus(context, payload){
    try{
        let url = "api/getmenus"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setMenus', response.data)

    }catch(error){
        context.commit('menusError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}
export async function crearMenu(context, payload){
    try{
        let url = "api/crearmenu"
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('description',payload.description)
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        context.dispatch('fetchMenus')

    }
    catch(error){
        context.commit('menusError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }

}
export async function getId(context,payload){
    try{
        let url = "api/getmenuid"
        context.commit('setLoading',true,{root:true})
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('id', payload)
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setId', response.data)
    }
    catch(error){
        context.commit('menusError',error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }

}